import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon } from 'lucide-react';
import { compras } from '../data/compras';
const SHOW_EVERY_MS = 15000;
const VISIBLE_MS = 6000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimeout: number;
    const cycle = () => {
      setVisible(true);
      hideTimeout = window.setTimeout(() => {
        setVisible(false);
        setIndex(current => (current + 1) % compras.length);
      }, VISIBLE_MS);
    };
    const firstTimeout = window.setTimeout(cycle, 5000);
    const interval = window.setInterval(cycle, SHOW_EVERY_MS);
    return () => {
      window.clearTimeout(firstTimeout);
      window.clearTimeout(hideTimeout);
      window.clearInterval(interval);
    };
  }, []);
  const compra = compras[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-6 left-4 z-50" data-id="element-196" data-mp="1gynft8kxm4hr">
      <AnimatePresence data-id="element-197" data-mp="16466cpfzqpcr">
        {visible ? <motion.a key={`${compra.name}-${index}`} href="#plan-sistema-total" initial={{
        opacity: 0,
        x: -16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -16,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="popup-dorado pointer-events-auto flex max-w-[300px] items-start gap-3 rounded-2xl border-2 border-gold bg-pistacho px-4 py-3 shadow-lift transition-transform duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2" data-id="element-198" data-mp="117fr24c0fxse">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-lime-600" aria-hidden="true" data-id="element-199" data-mp="28kg40kotdjun" />
            <div data-id="element-200" data-mp="23kbmcrc66j2u">
              <p className="font-display text-sm font-bold leading-tight text-forest-900" data-id="element-201" data-mp="23kv3w6xwr5gc">
                {compra.name} acaba de comprar
              </p>
              <p className="mt-1 text-[13px] leading-snug text-forest-700" data-id="element-202" data-mp="2fnecnqf5daw1">
                {compra.product}
              </p>
              <p className="mt-1.5 inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide text-forest-600/70" data-id="element-203" data-mp="2knskb7cu6itj">
                <MapPinIcon className="h-3 w-3" aria-hidden="true" data-id="element-204" data-mp="2pjrbf2pjuexn" />
                {compra.city}
              </p>
            </div>
          </motion.a> : null}
      </AnimatePresence>
    </div>;
}